import { FC, ReactNode } from 'react';
import { styled } from '@mui/material';
import Typography, { TypographyProps } from '../Typography';
import { DotFill } from '@o2/icons';

const Item = styled('div', {
  name: 'TextList',
  slot: 'Item',
})(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'start',
  flexWrap: 'nowrap',
  gap: theme.spacing(1),
  '& p': {
    lineHeight: '18px',
  },
}));

const Icon = styled(Typography, {
  name: 'TextList',
  slot: 'Item-Icon',
  shouldForwardProp: (propName) => propName !== 'defaultIcon',
})<{ defaultIcon: boolean; component: 'span' }>(({ defaultIcon }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: 18,
  fontSize: defaultIcon ? 6 : 14,
  flexBasis: defaultIcon ? 6 : 14,
  flexGrow: 0,
  flexShrink: 0,
  '& svg': {
    fontSize: defaultIcon ? 6 : 14,
  },
}));

export interface TextListItemProps extends Pick<TypographyProps, 'color'> {
  children: ReactNode;

  /**
   * ListItem icon, default is 6px DotFill
   */
  icon?: ReactNode;

  /**
   * Icon color
   */
  iconColor?: TypographyProps['color'];
}

/**
 * TextList consists of two components `TextList` and `TextList.Item`.
 */
const TextListItem: FC<TextListItemProps> = ({ children, icon, iconColor, ...other }) => {
  return (
    <Item>
      <Icon color={iconColor} component="span" defaultIcon={!icon}>
        {icon ? icon : <DotFill />}
      </Icon>
      <Typography flexGrow={1} component="span" {...other}>
        {children}
      </Typography>
    </Item>
  );
};

export default TextListItem;
